module.exports = __webpack_public_path__ + "static/media/focus.211d8efe.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程星享/focus.png
// module id = 691
// module chunks = 0